"use client";

import React from "react";
import {useTranslation} from "react-i18next";
import {
   EMPTY_CAPTIONS_TRACK_SRC,
   getMediaTrackSrcLang,
} from "@/utils/common/mediaTrackLanguage";

const InlineVideoPreview: React.FC<{url: string; mimeType: string}> = ({url, mimeType}) => {
   const {t, i18n} = useTranslation("ask");
   const captionSrcLang = getMediaTrackSrcLang(i18n);
   return (
      <div className="flex items-center justify-center h-full bg-black">
         <video controls className="max-w-full max-h-full" preload="metadata">
            <source src={url} type={mimeType} />
            <track
               kind="captions"
               src={EMPTY_CAPTIONS_TRACK_SRC}
               srcLang={captionSrcLang}
               label={t("a11y.captionsUnavailable")}
            />
            {t("preview.videoUnsupported")}
         </video>
      </div>
   );
};

export default InlineVideoPreview;
